import * as React from "react";
import { forwardRef } from "react";
const TubeSpinnerIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  preserveAspectRatio: "xMidYMid",
  viewBox: "0 0 100 100",
  fill: "currentColor",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeDasharray: "175 45",
  strokeWidth: 10,
  d: "M50 15a35 35 0 1 1-.01 0"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  dur: "1s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "rotate",
  values: "0 50 50;360 50 50"
})));
const ForwardRef = forwardRef(TubeSpinnerIcon);
export { ForwardRef as TubeSpinnerIcon };